import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { blockMenuMessages } from '@atlaskit/editor-common/messages';
import { SyncBlocksIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import Lozenge from '@atlaskit/lozenge';
import { canBeConvertedToSyncBlock } from '../pm-plugins/utils/utils';
var CreateSyncedBlockDropdownItem = function CreateSyncedBlockDropdownItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['selection', 'blockControls', 'connectivity'], function (states) {
      var _states$selectionStat, _states$blockControls, _states$blockControls2, _states$connectivityS;
      return {
        selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection,
        menuTriggerByNode: (_states$blockControls = (_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.menuTriggerByNode) !== null && _states$blockControls !== void 0 ? _states$blockControls : undefined,
        mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
      };
    }),
    selection = _useSharedPluginState.selection,
    menuTriggerByNode = _useSharedPluginState.menuTriggerByNode,
    mode = _useSharedPluginState.mode;
  var isNested = menuTriggerByNode && menuTriggerByNode.rootPos !== menuTriggerByNode.pos;
  var canBeConverted = useMemo(function () {
    return selection && canBeConvertedToSyncBlock(selection);
  }, [selection]);
  if (isNested || !canBeConverted) {
    return null;
  }
  var onClick = function onClick() {
    var _api$core, _api$core2, _api$blockControls;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 ? void 0 : api.syncedBlock.commands.insertSyncedBlock());
    api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.toggleBlockMenu({
      closeMenu: true
    }));
  };
  var isOffline = mode === 'offline';
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(SyncBlocksIcon, {
      label: ""
    }),
    onClick: onClick,
    isDisabled: isOffline,
    elemAfter: /*#__PURE__*/React.createElement(Lozenge, {
      appearance: "new"
    }, formatMessage(blockMenuMessages.newLozenge))
  }, formatMessage(blockMenuMessages.createSyncedBlock));
};
var CopySyncedBlockDropdownItem = function CopySyncedBlockDropdownItem(_ref2) {
  var api = _ref2.api;
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var _useSharedPluginState2 = useSharedPluginStateWithSelector(api, ['connectivity'], function (states) {
      var _states$connectivityS2;
      return {
        mode: (_states$connectivityS2 = states.connectivityState) === null || _states$connectivityS2 === void 0 ? void 0 : _states$connectivityS2.mode
      };
    }),
    mode = _useSharedPluginState2.mode;
  var onClick = function onClick() {
    var _api$core3, _api$core4, _api$blockControls2;
    api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(api === null || api === void 0 ? void 0 : api.syncedBlock.commands.copySyncedBlockReferenceToClipboard());
    api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.toggleBlockMenu({
      closeMenu: true
    }));
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(SyncBlocksIcon, {
      label: ""
    }),
    onClick: onClick,
    isDisabled: mode === 'offline',
    elemAfter: /*#__PURE__*/React.createElement(Lozenge, {
      appearance: "new"
    }, formatMessage(blockMenuMessages.newLozenge))
  }, formatMessage(blockMenuMessages.copySyncedBlock));
};
export var CreateOrCopySyncedBlockDropdownItem = function CreateOrCopySyncedBlockDropdownItem(_ref3) {
  var api = _ref3.api;
  var _useSharedPluginState3 = useSharedPluginStateWithSelector(api, ['blockControls'], function (states) {
      var _states$blockControls3, _states$blockControls4;
      return {
        menuTriggerByNode: (_states$blockControls3 = (_states$blockControls4 = states.blockControlsState) === null || _states$blockControls4 === void 0 ? void 0 : _states$blockControls4.menuTriggerByNode) !== null && _states$blockControls3 !== void 0 ? _states$blockControls3 : undefined
      };
    }),
    menuTriggerByNode = _useSharedPluginState3.menuTriggerByNode;
  if ((menuTriggerByNode === null || menuTriggerByNode === void 0 ? void 0 : menuTriggerByNode.nodeType) === 'syncBlock' || (menuTriggerByNode === null || menuTriggerByNode === void 0 ? void 0 : menuTriggerByNode.nodeType) === 'bodiedSyncBlock') {
    return /*#__PURE__*/React.createElement(CopySyncedBlockDropdownItem, {
      api: api
    });
  } else {
    return /*#__PURE__*/React.createElement(CreateSyncedBlockDropdownItem, {
      api: api
    });
  }
};